<template>
	<div class="auth">
		<div class="auth-container">
			<div class="col-12 col-lg-4 col-md-4">
				<LogoContainer />
			</div>
			<div class="col-12 col-lg-4 col-md-8">
				<div class="auth-card" v-if="isSetNewPassword">
					<div class="auth-card-header">
						<p class="h2 text-center">/ BUILDlite /</p>
					</div>
					<div class="auth-card-body">
						<form>
							<h2 class="text-left">Forgot your password?</h2>

							<BaseInput
								label="Enter your Email below and we will send a message to reset your password"
								type="email"
								v-model="username"
								:errorMsg="validationErrors.username"
							/>
							<button
								class="btn-login mt-0"
								@click.prevent="resetPassword"
							>
								Reset my password
							</button>
						</form>
					</div>
				</div>

				<div class="auth-card" v-if="!isSetNewPassword">
					<div class="auth-card-header">
						<p class="h2 text-center">/ BUILDlite /</p>
					</div>
					<div class="auth-card-body">
						<form>
							<p class="text-left">
								We have sent a password reset code by email to
								{{ username }}. Enter it below to reset your
								password.
							</p>
							<BaseInput
								label="Code"
								v-model="code"
								:errorMsg="validationErrors.code"
							/>
							<BaseInput
								label="New Password"
								type="password"
								v-model="newPassword"
								:errorMsg="validationErrors.newPassword"
							/>
							<!-- <BaseInput
						label="Enter New Password Again"
						type="password"
						v-model="newPasswordConfirm"
							/>-->
							<button
								class="btn-login"
								@click.prevent="changePassword"
							>
								Change Password
							</button>
						</form>
						<!-- Default form subscription -->
					</div>
					<!-- Card body -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CognitoService from '@/services/CognitoService.js'
import LogoContainer from '@/components/LogoContainer.vue'
import * as yup from 'yup'
import { getValidationErrors } from '@/utils/Help.js'
import NProgress from 'nprogress'

const resetPasswordSchema = yup.object().shape({
	username: yup
		.string()
		.label('User Name')
		.required("User Name can't be empty.")
})

const changePasswordSchema = yup.object().shape({
	code: yup
		.number()
		.typeError('Verification Code must be a number')
		.label('Verification Code')
		.required("Verification Code can't be empty."),
	newPassword: yup
		.string()
		.label('New Password')
		.required("New Password can't be empty.")
})

export default {
	name: 'ForgetPassword',
	data() {
		return {
			username: '',
			code: '',
			newPassword: '',
			newPasswordConfirm: '',
			isSetNewPassword: true,
			errorMsg: '',
			validationErrors: {}
		}
	},
	components: {
		LogoContainer
	},
	methods: {
		async resetPassword() {
			const userInput = {
				username: this.username
			}
			NProgress.start()
			try {
				await resetPasswordSchema.validate(userInput, {
					abortEarly: false
				})
				this.confirmPassword = await CognitoService.forgetYourPassword(
					this.username
				)
				this.isSetNewPassword = false
				this.errorMsg = ''
				NProgress.done()
			} catch (err) {
				if (err.name === 'ValidationError') {
					this.validationErrors = getValidationErrors(err)
				}
				this.errorMsg = err.message
				NProgress.done()
			}
		},
		async changePassword() {
			const userInput = {
				code: this.code,
				newPassword: this.newPassword
			}
			NProgress.start()
			try {
				await changePasswordSchema.validate(userInput, {
					abortEarly: false
				})
				this.confirmPassword(this.code, this.newPassword)
				NProgress.done()
			} catch (err) {
				console.log(err)
				if (err.name === 'ValidationError') {
					this.validationErrors = getValidationErrors(err)
				}
				this.errorMsg = err.message
				NProgress.done()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/views/auth.scss';
</style>
